<template>
  <div class="container container-table">
    <div class="row vertical-10p">
      <template v-for="alert in alerts">
        <b-alert :show="alert.type === 'danger' && loggedIn ? true : alert.dismiss" dismissible :variant="alert.type">
          <h4>
            <i v-if="alert.type === 'success'" class="icon fa fa-check"></i>
            <i class="icon fa fa-ban" v-else></i>
            {{`alert_${alert.type}` | translate }}!</h4>
         <span v-if="alert.type === 'danger' && loggedIn">{{'alert_error_1' | translate }}<a href="mailto:mirapodo@schuhe.de">mirapodo@schuhe.de</a>{{'alert_error_2' | translate }} </span>
         <span v-else>{{alert.message}}</span>
        </b-alert>
      </template>
      <div class="container">
        <div v-if="loggedIn" class="login-box box">
          <div class="login-logo">
            <router-link to="/">
              <img class="img-responsive center-block" src="/static/img/logo-lg.svg">
            </router-link>
          </div>
          <div class="login-box-body">
            <p class="login-box-msg">
              <span>Um Rücksendeunterlagen zur gewünschten Bestellung herunterzuladen, geben Sie bitte die <span class="text-warning">Kunden Postleitzahl der Lieferadresse</span> und die <span class="text-warning">Mirapodo Bestellnummer</span> ein.</span>
            </p>
            <div class="form-group has-feedback">
              <input v-validate="'required'" data-vv-as="'Postleitzahl'" :disabled="disabled" type="text" name="zipCode" class="form-control" placeholder="Kunden Postleitzahl" v-model="zipCode">
              <span class="fa fa-home form-control-feedback"></span>
              <span v-show="errors.has('zipCode')" class="small text-danger">{{ errors.first('zipCode') }}</span>
            </div>
            <div class="form-group has-feedback">
              <input v-validate="'required'" data-vv-as="'Bestellnummer'" :disabled="disabled" type="text" name="orderNumber" class="form-control" placeholder="Mirapodo Bestellnummer" v-model="orderNumber">
              <span class="fa fa-hashtag form-control-feedback"></span>
              <span v-show="errors.has('orderNumber')" class="small text-danger">{{ errors.first('orderNumber') }}</span>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <button :disabled="disabled || errors.any()" class="btn btn-success btn-block" @click="getOrder">
                  <i class="fa fa-download mr-5"></i>Rücksendeunterlagen herunterladen
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 text-center mt-10">
                <small class="text-muted"><i class="fa fa-info-circle mr-5"></i>Im Falle eines Fehlers wenden Sie sich bitte an <a href="mailto:mirapodo@schuhe.de">'mirapodo@schuhe.de'</a></small>
              </div>
            </div>
          </div>
          <div class="overlay" v-show="loading">
            <img class="loading-gif" src="/static/img/blabla.svg"/>
          </div>
        </div>
        <div v-else class="login-box box">
          <div class="login-logo">
            <router-link to="/">
              <img class="img-responsive center-block" src="/static/img/logo-lg.svg">
            </router-link>
          </div>
          <div class="login-box-body">
            <p class="login-box-msg">
              <span>Bitte einloggen</span>
            </p>
            <div class="form-group has-feedback">
              <input v-validate="'required'" data-vv-as="'Benutzername'" :disabled="disabled" type="text" name="username" class="form-control" placeholder="Benutzername" v-model="user.username">
              <span class="fa fa-user form-control-feedback"></span>
              <span v-show="errors.has('username')" class="small text-danger">{{ errors.first('username') }}</span>
            </div>
            <div class="form-group has-feedback">
              <input v-validate="'required'" data-vv-as="'Kennwort'" :disabled="disabled" type="password" name="password" class="form-control" placeholder="Kennwort" v-model="user.password">
              <span class="fa fa-lock form-control-feedback"></span>
              <span v-show="errors.has('password')" class="small text-danger">{{ errors.first('password') }}</span>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <button :disabled="disabled || errors.any()" class="btn btn-success btn-block" @click="login">
                  <i class="fa fa-sign-in mr-5"></i>Sign In
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 text-center mt-10">
                <small class="text-muted"><i class="fa fa-info-circle mr-5"></i>Im Falle eines Fehlers wende Sie sich bitte an <a href="mailto:mirapodo@schuhe.de">'mirapodo@schuhe.de'</a></small>
              </div>
            </div>
          </div>
          <div class="overlay" v-show="loading">
            <img class="loading-gif" src="/static/img/blabla.svg"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { sha256, sha224 } from 'js-sha256'
  import Api from '@/services/Api'

  export default {
    name: 'Login',
    data () {
      return {
        section: 'Login',
        zipCode: null,
        orderNumber: null,
        ticketNumber: '',
        loading: false,
        response: '',
        alerts: [],
        disabled: false,
        loggedIn: false,
        user: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      getOrder () {
        this.$validator.validate().then(valid => {
          if (!valid) {
           return true
          }
          let userInput = {orderId: this.orderNumber, orderDeliveryZip: this.zipCode}
          if (this.ticketNumber !== '') {
            userInput.ticket = this.ticketNumber
          }
          this.loading = true
          Api().post(`/v1/tools/mirapodo?order_id=${this.orderNumber}&order_delivery_zip=${this.zipCode}`)
            .then(response => {
              this.loading = false
              let index = 1
              response.data.message.forEach(file => {
                const url = window.URL.createObjectURL(this.b64toBlob(file))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `file-${index}.pdf`)
                document.body.appendChild(link)
                link.click()
                index++
              })
              let alert = {type: 'success', dismiss: 4, message: response.data.state}
              this.alerts.push(alert)
            })
            .catch(error => {
              this.loading = false
              let alert = {type: 'danger', dismiss: 4, message: ''}
              this.alerts.push(alert)
            })
        });
      },
      b64toBlob (b64Data, contentType='', sliceSize=512)  {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      },
      login () {
        this.loading = true
        if (sha256(this.user.password) === process.env.VUE_APP_HASH) {
          this.loggedIn = true
          this.alerts = []
          let alert = {type: 'success', dismiss: 4, message: 'Successful login'}
          this.alerts.push(alert)
          this.loading = false
        } else {
          this.loading = false
          let alert = {type: 'danger', dismiss: 4, message: 'Error, password incorrect'}
          this.alerts.push(alert)
        }
      }
    },
  }
</script>

<style scoped>
  .loading-gif {
    top: 43%;
    left: 39%;
    width: 23%;
    position: absolute;
  }
</style>
